"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDITION_PRICES_PER_SEAT = exports.EDITIONS = void 0;
exports.EDITIONS = [
    "Lite",
    "Starter",
    "Business",
    "Enterprise",
];
exports.EDITION_PRICES_PER_SEAT = {
    Lite: { monthly: 0, annual: 0 },
    Starter: { monthly: 10, annual: 8 },
    Business: { monthly: 15, annual: 12 },
    Enterprise: { annual: 18 },
};
